import React from "react";
import TotalStaffIcon from "../../assets/images/TotalStaffIcon";
import PendingStaffIcon from "../../assets/images/PendingStaffIcon";
import conflictingStaffIcon from "../../assets/images/conflictStaffIcon";
import ActiveStaffIcon from "../../assets/images/ActiveStaffIcon";
interface TileProps {
  title: string;
  count: number;
  textStyle?: any;
}
const Tile = ({ title, count, textStyle = "subTitle" }: TileProps) => {
  const componentMap: Record<
    string,
    { icon: React.ComponentType<any>; style: string }
  > = {
    "Active Staff": {
      icon: ActiveStaffIcon,
      style: "bg-activeStaffTileColor border-activeStaffTileBorderColor",
    },
    "Conflicting User": {
      icon: conflictingStaffIcon,
      style:
        "bg-conflictingStaffTileColor border-conflictingStaffTileBorderColor",
    },
    "Pending Staff": {
      icon: PendingStaffIcon,
      style: "bg-pendingTileColor border-pendingTileBorderColor",
    },
    "Total Staff": {
      icon: TotalStaffIcon,
      style: "bg-totalTileColor border-totalTileBorderColor",
    },
  };
  const SelectedComponent = componentMap[title]?.icon;
  return (
    <>
      <div className="block lg:hidden">
        <div
          className={`  mt-2 pl-2 border h-[10vh] w-[20vw]  rounded-lg  bg-whiteColor `}
        >
          <div className="flex  flex-col justify-between py-2  h-full">
            <div
              className={`${textStyle?.title} text-inputTextColor text-wrap pr-4 `}
            >
              {title}
            </div>
            <div
              className={`${textStyle.count} text-inputTextColor `}
            >
              {count}
            </div>
          </div>
        </div>
      </div>
      <div className=" hidden lg:block">
        <div className="mt-4 pt-6 pl-6  border-2 border-tileBorder rounded-lg ml-6  h-[120px] bg-whiteColor ">
          <div className="flex justify-between">
            <div className={`${textStyle} text-inputTextColor `}>
              {title}
            </div>
            <div className="pr-2">
              <div className="rounded-lg flex justify-center items-center ml-4 mr-3 bg-sideMenubackground h-10 w-10">
                {SelectedComponent && <SelectedComponent />}
              </div>
            </div>
          </div>
          <div>
            <div className="ml-4 mt-2  dashBoardTileCount text-dashBoardTileCountColor">
              {count}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Tile;
